module.exports = "/_next/static/images/about-feature01-5bf9462ed23a5c8de1b47cb92f34e678.jpg";